
import { DataSource, DataSourceExecutionEvent, DataSourceMode, Panel, SelectionEvent } from "@mcleod/components";
import { CurrencySettings, ErrorHandlerFunction, HorizontalAlignment, MapSettings, ModelRow, Navigation } from "@mcleod/core";
import { PortalCustomerSettings } from "@mcleod/portal-customer";
import { AutogenLayoutOrderDetailsUnauthenticated } from "./autogen/AutogenLayoutOrderDetailsUnauthenticated";

export class OrderDetailsUnauthenticated extends AutogenLayoutOrderDetailsUnauthenticated {

    private orderId: string;

    public override onLoad() {
        this.layoutFTLAddlDetails.visible = false;
        this.layoutLTLAddlDetails.visible = false;
        const showEta = this.shouldShowEta();
        this.panelEta.visible = showEta;
        this.panelMapEta.visible = showEta;
        if (MapSettings.getSingleton().noDistanceCalcVendor() === true)
            this.tabMapView.visible = false;

        this.textboxFreightCharge.printableLabel.align = HorizontalAlignment.RIGHT;
        this.textboxOtherChargeTotal.printableLabel.align = HorizontalAlignment.RIGHT;
        this.textboxExciseTaxTotal.printableLabel.align = HorizontalAlignment.RIGHT;
        this.textboxTotalChargeAndExciseTax.printableLabel.align = HorizontalAlignment.RIGHT;
    }

    /** This is an event handler for the afterExecution event of sourceCustomerOrderDetail.  */
    sourceCustomerOrderDetailAfterExecution(event: DataSourceExecutionEvent) {
        this.orderId = event.dataSource.activeRow?.get("orders.id");
        const isLtl = event.dataSource.activeRow?.get("is_ltl");
        const rates = event.dataSource.activeRow?.get("show_rates");
        if (isLtl == false) {
            this.layoutFTLAddlDetails.visible = true;
            this.layoutLTLAddlDetails.visible = false;
        }
        else {
            this.layoutLTLAddlDetails.visible = true;
            this.layoutFTLAddlDetails.visible = false;

        }
        if (CurrencySettings.getSingleton().multiCurrencyEnabled()) {
            const exciseTaxable = event.dataSource.activeRow?.getBoolean("customer.excise_taxable", false);
            this.textboxExciseTaxTotal.visible = exciseTaxable;
        }

        if (rates == false) {
            this.panelRateDetails.visible = false;
        } else {
            this.panelRateDetails.visible = true;
        }
    }

    shouldShowEta(): boolean {
        return PortalCustomerSettings.get()?.display_eta != "N";
    }

    // Adds panelAddlDetails to the selected tab.
    // each tab contains a panel where id = [tab.id]+AddlDetails  ex: paneltabStopsAddlDetails, paneltabMapViewAddlDetails ...
    tabsetBeforeTabSelection(event: SelectionEvent) {
        const tabId = event.newSelection?.id
        const panel = this["panel" + tabId + "AddlDetails"] as Panel;
        if (panel != null) {
            panel.add(this.panelAddlDetails);
        }
    }
}
